// Memory storage for user data
let userData = null;

export const saveUserData = (data) => {
  userData = data;
};

export const getUserData = () => {
  return userData;
};

export const clearUserData = () => {
  userData = null;
};
